import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';

import browser from '@openclassrooms/utils/browser';

import { wrapElementWithStoreProvider } from 'Modules/store/';
import AppProviders from 'Modules/webapp/components/AppProviders';

import ModalRoot from './components/ModalRoot';
import AlertModal from './components/AlertModal';
import reducers from './reducers';
import * as actions from './actions';

function init() {
  Modal.setAppElement('body');
  const targetElement = browser.document.createElement('div');
  browser.document.body.appendChild(targetElement);

  const root = createRoot(targetElement);
  root.render(
    wrapElementWithStoreProvider(
      <AppProviders productionPrefix="modal">
        <ModalRoot />
      </AppProviders>
    )
  );
}

export * from './constants/constants';
export { reducers, AlertModal };

export default {
  init,
  actions,
};
